import React, { useEffect } from 'react';
import Select from '../../../components/UI/Select/Select';
import './style.css';
import { useTranslation } from 'react-i18next';
import useForm from './useForm';
import Input from '../../../components/UI/Input/Input';
const Profile = ({ user }) => {
  console.log('🚀 Profile: Component mounted');
  console.log('🔍 Profile: User prop received:', user);
  console.log('🔍 Profile: User type:', typeof user);
  console.log('🔍 Profile: User.student:', user?.student);
  
  const { t, i18n } = useTranslation();
  const {
    submitHandler,
    resetFormState,
    loading,
    field,
    establishments,
    sendPasswordResetEmail,
    isEmailVerified,
    sendAccountVerificationEmail,
    accountVerificationEmailSent,
  } = useForm(user);

  return (
    <div className="profile-container container">
      <div className="title-container"></div>
      <div className="row col-md-4">
        <div className="form-container">
          <div className="input-divider">
            <Input
              type="text"
              placeholder={t('profile.form.firstName')}
              label={t('profile.form.firstName')}
              {...field('firstName')}
            />
          </div>
          <div className="input-divider">
            <Input
              type="text"
              placeholder={t('profile.form.lastName')}
              label={t('profile.form.lastName')}
              {...field('lastName')}
            />
          </div>
          <div className="input-divider">
            <Input type="email" placeholder={t('profile.form.email')} label={t('profile.form.email')} {...field('email')} />
          </div>
          <div className="input-divider">
            <Input type="text" placeholder={t('profile.form.phone')} label={t('profile.form.phone')} {...field('phone')} />
          </div>
          <div className="input-divider">
            <Input
              type="text"
              placeholder={t('personal-information.form.matricule-bac')}
              label={t('personal-information.form.matricule-bac')}
              {...field('bac_matricule')}
            />
          </div>
          <div className="input-divider">
            <Select placeholder={t('profile.form.gender')} label={t('profile.form.gender')} {...field('gender')}>
              <option value="" disabled selected>
                {t('profile.form.gender')}
              </option>
              <option value="F">{t('personal-information.form.female')}</option>
              <option value="M">{t('personal-information.form.male')}</option>
            </Select>
          </div>
          <button
            className=" input-divider reset-password-btn"
            type="button"
            disabled={loading}
            onClick={() => sendPasswordResetEmail()}
          >
            <span className="glyphicon glyphicon-repeat"></span> {t('profile.form.reset-password')}{' '}
          </button>

          <button className="profile-save-button" type="button" disabled={loading} onClick={() => submitHandler()}>
            {t('profile.form.save')}{' '}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
